import React from 'react';
import { Typography, Card, CardContent, Container, Button } from '@mui/material';

const Lessons = () => {
  return (
    <Container sx={{ py: 15 }}>

      {/* Private Lessons */}
      <Card sx={{ mb: 6, p: 3, textAlign: 'center' }}>
        <CardContent>
          <Typography variant="h4" gutterBottom>
            PRIVATE LESSONS
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            Private lessons are one hour long and offer the best opportunity to improve your game one-on-one. These lessons are tailored to your skill level and goals. Led by experienced, certified instructors, our personalized sessions will diagnose the key areas for you to create an efficient and repeatable swing, improve your putting, and build consistency in all areas of your short game.
          </Typography>

          <Typography variant="h5" gutterBottom textAlign="left">
            WHAT YOU GET:
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            All lessons include video analysis, launch monitor data, and other feedback tools to ensure progress is visible and can be tracked. You will be added to our online platform so you can rewatch swings and instructions from your lesson. You will also be given drills that you can work on at the range and from home to ensure you have the best opportunity to improve from anywhere.
          </Typography>

          <Typography variant="h5" gutterBottom textAlign="left">
            PRICES
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            Junior Lessons $80 + HST  
            <br />
            Adult Lessons $100 + HST
          </Typography>

          <Button
            sx={{ mt: 2 }}
            variant="contained"
            color="primary"
            href="https://www.picktime.com/glga"
            target="_blank"
          >
            Book Now
          </Button>
        </CardContent>
      </Card>

      {/* Junior Development Package */}
      <Card sx={{ mb: 6, p: 3, textAlign: 'center' }}>
        <CardContent>
          <Typography variant="h4" gutterBottom>
            JUNIOR DEVELOPMENT PACKAGE
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            This is designed for aspiring young golfers looking to develop key fundamentals in all areas of their game. Our Junior Mentorship Program provides a structured and engaging learning experience. This program offers five hour-long lessons and a guided 9-hole lesson — an ideal way to build both technical skills and on-course confidence.
          </Typography>

          <Typography variant="h5" gutterBottom textAlign="left">
            WHAT YOU GET:
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            Each lesson is led by an experienced instructor who focuses on foundational swing mechanics, short game skills, and a focus on learning how to practice effectively. Throughout the program, juniors will gain essential insights into their swing and how to approach the game of golf with reasonable expectations and set realistic goals.
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            Lessons include video analysis, launch monitor data, and other feedback tools to ensure visible progress. Participants will be added to our online platform, where they can review swings, instructions, and drills tailored to their improvement. Practice drills are provided so learning can continue both at the range and at home, helping students develop their game beyond each lesson.
          </Typography>

          <Typography variant="h5" gutterBottom textAlign="left">
            PRICE
          </Typography>

          <Typography variant="h6" gutterBottom textAlign="left">
            Junior Mentorship Program – $500 + HST
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            To register for this package or seek more information, please email me directly: <strong>jc.glgolf@gmail.com</strong>
          </Typography>
        </CardContent>
      </Card>

      {/* Elite Mentorship Package */}
      <Card sx={{ mb: 6, p: 3, textAlign: 'center' }}>
        <CardContent>
          <Typography variant="h4" gutterBottom>
            ELITE MENTORSHIP PACKAGE
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            The Junior Elite Mentorship Package is designed for elite junior golfers, collegiate and professional golfers looking to maximise their potential. This program is designed to refine skills, enhance physical performance, and prepare players to compete at the highest levels.
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            This comprehensive package includes five hour-and-a-half lessons and a full 18-hole on-course lesson, ensuring well-rounded development both on and off the course. This program also includes three private TPI Certified training sessions and a tailored fitness program with Cory Bannon at FitClub.
          </Typography>

          <Typography variant="h5" gutterBottom textAlign="left">
            WHAT YOU GET:
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            Led by experienced instructors and certified training professionals who have competed at the highest levels, this program focuses on optimizing swing mechanics, mastering short-game techniques, and developing key on-course strategies for competitive play.
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            There is an emphasis on goal setting, tracking practice season data, and developing professional practice habits to help them achieve their goals and maximize potential. Coaches will help develop specific on-course strategies based on students strengths to help get the most out of their game.
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            Each session incorporates video analysis, launch monitor data, and tailored feedback to track progress and fine-tune performance. Participants will gain access to our online platform to review swings, instructions, and training drills, enabling continuous improvement between sessions.
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            This mentorship program blends skill refinement with physical conditioning, ensuring students build the strength, mobility, nutritional knowledge, skill, strategy, discipline, and mental fortitude required to perform at their best. This is the total package.
          </Typography>

          <Typography variant="h5" gutterBottom textAlign="left">
            PRICE
          </Typography>

          <Typography variant="h6" gutterBottom textAlign="left">
            Elite Mentorship Program – $900 + HST
          </Typography>

          <Typography variant="body1" paragraph textAlign="left">
            To register for this package or seek more information, please email us directly: <strong>jc.glgolf@gmail.com</strong>
          </Typography>
        </CardContent>
      </Card>

    </Container>
  );
};

export default Lessons;